var _g, _path, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollabHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 38,
    viewBox: "0 0 620 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5777_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.103 33.997C273.34 34.0334 270.614 33.3661 268.182 32.0585C265.869 30.8118 263.949 28.9487 262.638 26.6773C261.284 24.3469 260.592 21.6933 260.637 19.0011C260.591 16.3087 261.283 13.6549 262.638 11.3249C263.957 9.05287 265.884 7.19009 268.202 5.94375C272.553 3.68993 277.66 3.38145 282.252 5.09502C284.052 5.79689 285.673 6.88875 286.997 8.29156L284.989 10.2803C282.683 7.9601 279.749 6.78494 276.241 6.78494C274.01 6.75483 271.809 7.30069 269.853 8.3694C267.984 9.40395 266.434 10.9256 265.367 12.7712C264.271 14.6634 263.712 16.8168 263.749 19.0011C263.712 21.1846 264.272 23.337 265.367 25.2285C266.438 27.0663 267.993 28.5779 269.863 29.6002C271.812 30.6901 274.016 31.2463 276.251 31.2122C279.78 31.2122 282.721 30.0371 284.999 27.6968L287 29.6629C285.665 31.0748 284.032 32.1735 282.219 32.8796C280.27 33.636 278.194 34.016 276.103 33.9995V33.997Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13 4.25H250.005V33.7521H253.13V4.25Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.456 6.95438H220.038V4.25H243.972V6.95438H233.584V33.7521H230.456V6.95438Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.754 23.5347V33.7521H200.656V23.5347L188.814 4.25H192.156L202.302 20.8052L212.446 4.25H215.57L203.754 23.5347Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.293 4.25H172.418V31.0477H188.978V33.7521H169.293V4.25Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.435 8.84016V4.25H159.039V8.84016H142.946H137.435Z",
    fill: "#00B3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.435 21.0229V16.5156H142.946H147.47H157.23V21.0229H147.633H142.946H137.435Z",
    fill: "#0078DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.642 29.1641V33.7542H137.435V29.1641H142.946H159.642Z",
    fill: "#004B96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8496 4.25H112.788C115.943 4.25 118.738 4.87776 121.205 6.08054C123.563 7.23519 125.541 9.03566 126.908 11.2708C128.251 13.5107 128.937 16.0795 128.937 19.0023C128.937 21.9251 128.251 24.4914 126.908 26.7313C125.545 28.9642 123.571 30.7637 121.218 31.919C118.59 33.1653 115.71 33.7909 112.8 33.7471H99.8496V29.1092H112.541C114.513 29.1503 116.468 28.7288 118.246 27.8788C119.845 27.1028 121.171 25.8656 122.054 24.3282C122.959 22.799 123.4 21.0237 123.4 19.0023C123.444 17.1375 122.979 15.2958 122.054 13.6739C121.171 12.137 119.844 10.9001 118.246 10.1233C116.468 9.27211 114.513 8.85057 112.541 8.89289H99.8496V4.25Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3182 26.9246L83.5088 22.6332L77.9419 9.74162L72.3497 22.6332L70.5403 26.9246L67.5792 33.7521H61.8232L75.1748 4.25H76.5986H79.2599H80.6837L94.0353 33.7521H88.2793L85.3182 26.9246Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2942 33.7471L45.246 25.1167C44.994 25.1443 44.616 25.1443 44.122 25.1443H37.4236V33.7471H32.3506V20.6345H43.865C46.2515 20.6345 48.0609 20.1172 49.2933 19.1053C50.5256 18.0933 51.1582 16.6193 51.1582 14.7361C51.1582 12.8528 50.5558 11.4014 49.2933 10.392C48.0307 9.38255 46.2515 8.88536 43.865 8.88536H32.3506V4.25H44.1019C46.6522 4.25 48.8901 4.68692 50.7902 5.53314C52.5879 6.2636 54.1218 7.51885 55.1903 9.13395C56.1984 10.7209 56.7024 12.5766 56.7024 14.7361C56.7024 16.9483 56.1555 18.8592 55.0845 20.4713C54.0134 22.0833 52.4182 23.2585 50.4021 24.0495L57.2064 33.7471H51.2942Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81543 4.25H25.1125V8.89541H15.2967V33.7521H9.81543V11.4893V8.89541V4.25Z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65968 4.25H0V8.89289H4.65968V4.25Z",
    fill: "#004B96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.416 12.5859L321.583 25.4193",
    stroke: "#221F20",
    strokeWidth: 2.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.583 12.5859L334.416 25.4193",
    stroke: "#221F20",
    strokeWidth: 2.33333,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5777_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369 0H384.76L409.646 25.1195V10.7128H400.835L390.278 0.0472423H406.647L421.738 15.2761V37.3149H405.979L381.081 12.1953V26.6132H389.892L400.461 37.2676H384.092L369 22.0386V0Z",
    fill: "url(#paint0_linear_5777_1565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.14 30.2153V7.00865H447.374V20.085L436.195 7.00865H431.8V30.2153H437.566V17.4915L448.676 30.2153H453.14ZM607.174 6.52699C600.19 6.52699 594.903 11.8565 594.903 18.6175C594.903 25.3786 600.188 30.6958 607.174 30.6958C614.159 30.6958 619.479 25.3663 619.479 18.6175C619.479 11.8689 614.194 6.52699 607.174 6.52699ZM607.174 25.3438C603.423 25.3438 600.73 22.2686 600.73 18.6175C600.73 14.9664 603.425 11.8914 607.174 11.8914C610.924 11.8914 613.608 14.9553 613.608 18.6175C613.608 22.2799 610.924 25.3438 607.174 25.3438ZM582.938 12.1619H590.298V7.00865H569.789V12.1619H577.185V30.2153H582.938V12.1619ZM554.345 6.49219C548.896 6.49219 545.146 9.42698 545.146 14.0751C545.146 17.761 547.29 19.9087 551.862 20.9068L555.681 21.7522C557.65 22.1283 558.131 22.9491 558.131 23.7361C558.131 25.0036 557.005 25.7783 554.861 25.7783C552.131 25.7783 550.36 24.5579 549.985 22.5034H544.232C544.771 28.2438 549.469 30.6969 554.684 30.6969C560.485 30.6969 564.306 27.798 564.306 23.1488C564.306 19.1575 561.541 17.4556 557.309 16.5282L554.074 15.7771C552.341 15.401 551.416 14.861 551.416 13.5934C551.416 12.0912 552.751 11.2694 554.719 11.2694C557.075 11.2694 558.165 12.4662 558.47 14.2042H564.27C563.684 7.95959 558.096 6.49219 554.345 6.49219ZM526.337 16.1532V12.0216H538.092V7.00976H520.571V30.2164H538.092V25.2046H526.337V21.073H536.591V16.1543L526.337 16.1532ZM504.352 30.3556L514.408 7.00865H508.068L501.458 22.7492L494.848 7.00865H488.509L498.564 30.3556H504.352ZM482.449 19.4045V7.00865H476.649V19.4979C476.649 23.0545 474.668 25.3438 471.645 25.3438C468.622 25.3438 466.665 23.0545 466.665 19.4979V7.00865H460.876V19.4045C460.876 26.6001 465.024 30.7318 471.645 30.7318C478.266 30.7318 482.449 26.6001 482.449 19.4045Z",
    fill: "#221F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5777_1565",
    x1: 369,
    y1: 0,
    x2: 424.994,
    y2: 5.78075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4482FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775DE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5777_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 30,
    fill: "white",
    transform: "translate(0 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5777_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 38,
    fill: "white",
    transform: "translate(369)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabHorizontal);
export default __webpack_public_path__ + "static/media/collab_horizontal.08ffaf414896328e6d93fd368a6bad2b.svg";
export { ForwardRef as ReactComponent };